export default __webpack_public_path__ + "static/media/download-icon.5170ba65.svg";